// extracted by mini-css-extract-plugin
export default {"untitledWrap":"AssemblyName_untitledWrap__lIztM","untitled":"AssemblyName_untitled__Hvlwu","badge":"AssemblyName_badge__48vNn"};